import { Separator } from "@/components/ui/separator";
import { Facebook, Twitter, Instagram, Linkedin, Github } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

interface FooterProps {
  onToggleVoiceAssistant?: () => void;
}

export default function Footer({ onToggleVoiceAssistant }: FooterProps) {
  const handleTwitterClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onToggleVoiceAssistant) {
      onToggleVoiceAssistant();
      console.log('Twitter icon clicked - toggling voice assistant');
    }
  };

  return (
    <footer className="bg-gradient-to-b from-gray-50 to-gray-100 pt-16 pb-8" data-id="3waorachh" data-path="src/components/navigation/Footer.tsx">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="xemgg9emh" data-path="src/components/navigation/Footer.tsx">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12" data-id="hlbv9j0qp" data-path="src/components/navigation/Footer.tsx">
          <div className="md:col-span-2" data-id="yk2wzjw88" data-path="src/components/navigation/Footer.tsx">
            <div className="mb-6" data-id="j6cboz5bs" data-path="src/components/navigation/Footer.tsx">
              <Logo variant="full" data-id="gd4qransh" data-path="src/components/navigation/Footer.tsx" />
            </div>
            <p className="text-gray-600 mb-6 max-w-md" data-id="g66chtz2e" data-path="src/components/navigation/Footer.tsx">
              Transforming businesses through intelligent automation. Our AI-powered solutions help companies 
              save time, reduce costs, and streamline operations for sustainable growth.
            </p>
            <div className="flex space-x-4" data-id="3la5ll5rg" data-path="src/components/navigation/Footer.tsx">
              <a
                href="https://www.facebook.com/share/1Autr9xLuL/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-600 transition-colors duration-200" data-id="577epf6zr" data-path="src/components/navigation/Footer.tsx">

                <Facebook size={24} data-id="ly5ab0snr" data-path="src/components/navigation/Footer.tsx" />
              </a>
              <a
                href="https://www.instagram.com/botlabhq?igsh=MWhkMzJsdGozamZscg=="
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-600 transition-colors duration-200" data-id="gcul3j7ih" data-path="src/components/navigation/Footer.tsx">

                <Instagram size={24} data-id="m2ru8f6j6" data-path="src/components/navigation/Footer.tsx" />
              </a>
              <a
                href="https://www.linkedin.com/company/botlabhq/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-600 transition-colors duration-200" data-id="58m5v5z0g" data-path="src/components/navigation/Footer.tsx">

                <Linkedin size={24} data-id="znzevzpta" data-path="src/components/navigation/Footer.tsx" />
              </a>
              <button
                onClick={handleTwitterClick}
                className="text-gray-400 hover:text-blue-600 transition-all duration-200 hover:scale-110 transform"
                title="Toggle Voice Assistant" data-id="wwk3c9geu" data-path="src/components/navigation/Footer.tsx">
                <Twitter size={24} data-id="a2ab12e3y" data-path="src/components/navigation/Footer.tsx" />
              </button>
              <a href="#" className="text-gray-400 hover:text-blue-600 transition-colors duration-200" data-id="9cg46gpsp" data-path="src/components/navigation/Footer.tsx">
                <Github size={24} data-id="gnd271ulx" data-path="src/components/navigation/Footer.tsx" />
              </a>
            </div>
          </div>
          
          <div data-id="0os6nwqcb" data-path="src/components/navigation/Footer.tsx">
            <h3 className="text-lg font-semibold text-gray-900 mb-6" data-id="xffvmmdby" data-path="src/components/navigation/Footer.tsx">Solutions</h3>
            <ul className="space-y-3" data-id="qashm6jjv" data-path="src/components/navigation/Footer.tsx">
              <li data-id="9go6dwwzn" data-path="src/components/navigation/Footer.tsx">
                <Link to="/use-cases" className="text-gray-600 hover:text-blue-600 transition-colors duration-200 font-medium" data-id="n0dlqgxzt" data-path="src/components/navigation/Footer.tsx">
                  AI Chatbots
                </Link>
              </li>
              <li data-id="l23ftkld8" data-path="src/components/navigation/Footer.tsx">
                <Link to="/use-cases" className="text-gray-600 hover:text-blue-600 transition-colors duration-200 font-medium" data-id="frct6ox5u" data-path="src/components/navigation/Footer.tsx">
                  Voice Assistant AI
                </Link>
              </li>
              <li data-id="2slx108qa" data-path="src/components/navigation/Footer.tsx">
                <Link to="/use-cases" className="text-gray-600 hover:text-blue-600 transition-colors duration-200 font-medium" data-id="oh8fvwmt4" data-path="src/components/navigation/Footer.tsx">
                  AI Content Generation
                </Link>
              </li>
              <li data-id="fm2wz2vc7" data-path="src/components/navigation/Footer.tsx">
                <Link to="/custom-solutions" className="text-gray-600 hover:text-blue-600 transition-colors duration-200 font-medium" data-id="fr403mppu" data-path="src/components/navigation/Footer.tsx">
                  Custom Solutions
                </Link>
              </li>
            </ul>
          </div>
          
          <div data-id="bquiqxy0y" data-path="src/components/navigation/Footer.tsx">
            <h3 className="text-lg font-semibold text-gray-900 mb-6" data-id="kt73uzwda" data-path="src/components/navigation/Footer.tsx">Company</h3>
            <ul className="space-y-3" data-id="3rxn2itm5" data-path="src/components/navigation/Footer.tsx">
              <li data-id="owdv45ogp" data-path="src/components/navigation/Footer.tsx">
                <Link to="/about" className="text-gray-600 hover:text-blue-600 transition-colors duration-200 font-medium" data-id="64pjx1shx" data-path="src/components/navigation/Footer.tsx">
                  About Us
                </Link>
              </li>
              <li data-id="id1why51k" data-path="src/components/navigation/Footer.tsx">
                <Link to="/case-studies" className="text-gray-600 hover:text-blue-600 transition-colors duration-200 font-medium" data-id="t7hs2u1ws" data-path="src/components/navigation/Footer.tsx">
                  Case Studies
                </Link>
              </li>
              <li data-id="26ey9uskp" data-path="src/components/navigation/Footer.tsx">
                <Link to="/industries" className="text-gray-600 hover:text-blue-600 transition-colors duration-200 font-medium" data-id="g3cdkzi12" data-path="src/components/navigation/Footer.tsx">
                  Industries
                </Link>
              </li>
              <li data-id="945yc4r0l" data-path="src/components/navigation/Footer.tsx">
                <Link to="/contact" className="text-gray-600 hover:text-blue-600 transition-colors duration-200 font-medium" data-id="wq3b0qsj3" data-path="src/components/navigation/Footer.tsx">
                  Contact
                </Link>
              </li>
              <li data-id="wi71rqdz1" data-path="src/components/navigation/Footer.tsx">
                <Link to="/privacy-policy" className="text-gray-600 hover:text-blue-600 transition-colors duration-200 font-medium" data-id="vrl0zudac" data-path="src/components/navigation/Footer.tsx">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="2w9jmdnx9" data-path="src/components/navigation/Footer.tsx">
                <Link to="/terms-of-service" className="text-gray-600 hover:text-blue-600 transition-colors duration-200 font-medium" data-id="6pj2f6hcq" data-path="src/components/navigation/Footer.tsx">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <Separator className="my-8" data-id="j2jhhfmox" data-path="src/components/navigation/Footer.tsx" />
        
        {/* All footer elements on the same line */}
        <div className="flex flex-col sm:flex-row justify-between items-center text-sm text-gray-500 space-y-2 sm:space-y-0" data-id="2agww4q7w" data-path="src/components/navigation/Footer.tsx">
          {/* Copyright */}
          <div className="flex-shrink-0" data-id="yk6exdnvg" data-path="src/components/navigation/Footer.tsx">
            <span data-id="40lzdje48" data-path="src/components/navigation/Footer.tsx">&copy; {new Date().getFullYear()} Bot Lab HQ. All rights reserved.</span>
          </div>
          
          {/* Trust badges - centered */}
          <div className="flex items-center space-x-2 sm:space-x-6" data-id="jefw0966z" data-path="src/components/navigation/Footer.tsx">
            <span data-id="m7wrgkebh" data-path="src/components/navigation/Footer.tsx">Trusted by 500+ businesses worldwide</span>
            <span className="hidden sm:inline" data-id="y63k1rvxo" data-path="src/components/navigation/Footer.tsx">•</span>
            <span data-id="k10ki86z1" data-path="src/components/navigation/Footer.tsx">24/7 AI-powered support</span>
          </div>
          
          {/* Made with love section */}
          <div className="flex items-center flex-shrink-0" data-id="yj9yu8uil" data-path="src/components/navigation/Footer.tsx">
            <span data-id="rzxkvdha2" data-path="src/components/navigation/Footer.tsx">Made with</span>
            <span className="mx-1 text-red-500 animate-pulse inline-block transform-gpu" data-id="1a5hwqeg1" data-path="src/components/navigation/Footer.tsx">
              <svg
                className="w-4 h-4 animate-bounce"
                style={{
                  animation: 'heartbeat 1.5s ease-in-out infinite'
                }}
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg" data-id="2s3o3f7pd" data-path="src/components/navigation/Footer.tsx">
                <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" data-id="pc5gus3fs" data-path="src/components/navigation/Footer.tsx" />
              </svg>
            </span>
            <span data-id="9kxdrnam7" data-path="src/components/navigation/Footer.tsx">by BotLabHQ</span>
          </div>
        </div>
      </div>
    </footer>);

}